/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_GroupInputs */

const en_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Group`)
};

const fr_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe cible`)
};

const de_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe`)
};

const it_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo target`)
};

const ru_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая группа`)
};

const es_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo objetivo`)
};

const zh_cn2_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标群体`)
};

const ja_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象グループ`)
};

const hi_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्षित समूह`)
};

const pt_pt2_target_group = /** @type {(inputs: Target_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público-alvo`)
};

/**
* | output |
* | --- |
* | "Target Group" |
*
* @param {Target_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_group = /** @type {((inputs?: Target_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_group(inputs)
	if (locale === "de") return de_target_group(inputs)
	if (locale === "it") return it_target_group(inputs)
	if (locale === "ru") return ru_target_group(inputs)
	if (locale === "es") return es_target_group(inputs)
	if (locale === "zh-CN") return zh_cn2_target_group(inputs)
	if (locale === "ja") return ja_target_group(inputs)
	if (locale === "hi") return hi_target_group(inputs)
	if (locale === "pt-PT") return pt_pt2_target_group(inputs)
	return en_target_group(inputs)
});